import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    CloseOutlined,
    SearchOutlined,
    CloudDownloadOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    EyeOutlined,
    EyeInvisibleOutlined
} from '@ant-design/icons';
import { Select, Drawer, Pagination } from 'antd';
import { TarifaActualizacionDescagarCSVEnAPI, ObtenerFamiliasByMarcaEnAPI, ObtenerTarifaPorActualizacionEnAPI } from "../../action/actionCreatorsRequests";
import { traducirPagina, obtenerFechaLocal, descargarDocPasandoBase64GenericoPorNombre } from "../../librerias/funciones"

const { Option } = Select;

const FichaActualizacion = ({ props }) => {

    const [ordenTabla, setOrdenTabla] = React.useState({
        ORDER_DIR: "A",
        ORDER_COLUM: 1,
        NUM_COLUM: 1,
        ACTIVO: true
    });

    const [bloqueoPantalla, setBloqueoPantalla] = React.useState({
        LOADER: true,
        MENSAJE: ""
    });

    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [hayCliente, setHayCliente] = React.useState(false);
    const [payLoadLocal, setPayLoadLocal] = React.useState({
        ID_ACTUALIZACION: 0,
        FECHA_VIGENCIA: "",
        ES_IMPORTE_PVP: true,
        DOCUMENTO_CSV: [],
        VALIDAR_TARIFA: false
    });

    const [tarifas, setTarifas] = React.useState([]);
    const [grupos, setGrupos] = React.useState([]);
    const [totalRegistros, setTotalRegistros] = React.useState(0);




    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 });
    const [filtroLocal, setFiltroLocal] = React.useState({
        ID_GRUPO_MONTAJE: null,
        TEXTO_BUSCADOR: "",
        LOADER_CSV: false,
        SIN_PRECIO: false
    });




    const GetGruposMontaje = async (ID_PROVEEDOR, ID_MARCA) => {
        let registro = await ObtenerFamiliasByMarcaEnAPI(ID_PROVEEDOR, ID_MARCA)
        if (registro !== undefined && registro !== null && registro.REGISTROS !== null && registro.REGISTROS.length > 0) {
            setGrupos(registro.REGISTROS)
        } else {
            setGrupos(null)
        }
        return registro;
    }

    const descargarFichero = async () => {
        bloqueoPantalla.LOADER = true;
        bloqueoPantalla.MENSAJE = `<div class="mensaje_Tarifas"> <div class="spinner-border  fast " role="status" disabled ></div>   <div class="txt_Tarifas"> ${traducirPagina("Se_estan_descargando")} ${totalRegistros} registros. <br/> ${traducirPagina("Msg_proceso_espera")} </div> </div>`;
        setBloqueoPantalla({ ...bloqueoPantalla })


        let registro = await TarifaActualizacionDescagarCSVEnAPI(
            props.ID_ACTUALIZACION,
            props.NOMBRE_MARCA
        )

        bloqueoPantalla.LOADER = false;
        bloqueoPantalla.MENSAJE = "";
        setBloqueoPantalla({ ...bloqueoPantalla })

        if (registro !== undefined && registro !== null && registro.FICHERO !== null && registro.FICHERO.length > 0) {

            let CREAR_FICHERO = `data:application/csv;base64,${registro.FICHERO}`;
            descargarDocPasandoBase64GenericoPorNombre(CREAR_FICHERO, registro.NOMBRE_FICHERO)
        }

    }



    const ObtenerTarifaPorActualizacion = async (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID_ACTUALIZACION, REFERENCIA, ID_FAMILIA, VER_SIN_PRECIO) => {
        bloqueoPantalla.LOADER = true;
        bloqueoPantalla.MENSAJE = "";
        setBloqueoPantalla({ ...bloqueoPantalla })
        setTarifas([])


        let registro = await ObtenerTarifaPorActualizacionEnAPI(REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID_ACTUALIZACION, REFERENCIA, ID_FAMILIA, VER_SIN_PRECIO)

        bloqueoPantalla.LOADER = false;
        bloqueoPantalla.MENSAJE = "";
        setBloqueoPantalla({ ...bloqueoPantalla })


        if (registro !== undefined) {
            if (registro !== null && registro.REGISTROS !== null && registro.REGISTROS.length > 0) {
                setTarifas(registro.REGISTROS)
                setTotalRegistros(registro.TOTAL_REGISTROS)
            } else {
                setTarifas(null)
                setTotalRegistros(0)
            }
        }
        return registro;
    }



    const verificarPrecio = (PRECIO) => {
        let MOSTRA_PRECIO = false;
        if (PRECIO !== undefined && PRECIO !== null && PRECIO !== "") {
            MOSTRA_PRECIO = parseFloat(PRECIO) > 0
        }
        return MOSTRA_PRECIO;
    }

    const colorPrecio = (PRECIO) => {
        let COLOR = "#dcdcdc";
        let RESULTADO = { COLOR, INCREMENTO: null }

        if (PRECIO !== undefined && PRECIO !== null && PRECIO !== "") {
            let IMPORTE = parseFloat(PRECIO)
            if (IMPORTE > 0) {
                COLOR = "green"
            } else if (IMPORTE < 0) {
                COLOR = "red"
            }
            RESULTADO = { COLOR, INCREMENTO: IMPORTE === 0 ? null : IMPORTE > 0 }
        }
        return RESULTADO;
    }


    const paginarTabla = (page, pageSize) => {
        if (totalRegistros > 0) {
            let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
            let pFinal = pageSize * page;
            setDatosPaginacion(
                {
                    iniPage: page,
                    inicio: pInicio,
                    final: pFinal,
                    numPagina: datosPaginacion.numPagina
                }
            )

            ObtenerTarifaPorActualizacion(pageSize, page, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, filtroLocal.TEXTO_BUSCADOR, filtroLocal.ID_GRUPO_MONTAJE, filtroLocal.SIN_PRECIO)
        }
    }


    const updateNumberPage = (current, size) => {
        ObtenerTarifaPorActualizacion(size, current, 1, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, filtroLocal.TEXTO_BUSCADOR, filtroLocal.ID_GRUPO_MONTAJE, filtroLocal.SIN_PRECIO)
        setDatosPaginacion(
            {
                iniPage: current,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }

    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })


    const ordenacionTabla = (ORDER_COLUM, ORDER_DIR) => {
        ObtenerTarifaPorActualizacion(datosPaginacion.numPagina, datosPaginacion.iniPage, ORDER_COLUM, ORDER_DIR, props.ID_ACTUALIZACION, filtroLocal.TEXTO_BUSCADOR, filtroLocal.ID_GRUPO_MONTAJE, filtroLocal.SIN_PRECIO)
    }


    if (!hayCliente && props.ABRIR_FICHA) {
        setHayCliente(true);
        let obtenerFechaLocalDesde = obtenerFechaLocal(true)

        //payLoadLocal.ID_MARCA = props.ID_MARCA;
        //payLoadLocal.ID_PROVEEDOR = props.ID_PROVEEDOR;
        payLoadLocal.ID_ACTUALIZACION = props.ID_ACTUALIZACION
        payLoadLocal.FECHA_VIGENCIA = obtenerFechaLocalDesde

        setPayLoadLocal({ ...payLoadLocal })


        GetGruposMontaje(props.ID_PROVEEDOR, props.ID_MARCA)

        ObtenerTarifaPorActualizacion(40, 1, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, "", 0, filtroLocal.SIN_PRECIO)

    } else {
        if (!props.ABRIR_FICHA && hayCliente) {
            setHayCliente(false);
        }
    }

    return (
        <>
            <Drawer
                width={"85%"}
                onClose={() => {
                    if (!bloqueoPantalla.LOADER) {
                        props.CERRAR_FICHA(false)

                    }
                }}
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => {
                            if (!bloqueoPantalla.LOADER) {
                                props.CERRAR_FICHA(false)

                            }
                        }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>
                </div>

                <div className="menu_mantenimiento" ref={ref}>

                    <div className='mantenimiento_item1'>
                        {
                            totalRegistros > 0 ?
                                <Pagination
                                    showSizeChanger
                                    current={datosPaginacion.iniPage}
                                    onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                    total={totalRegistros}
                                    showTotal={() => ` ${totalRegistros} ${traducirPagina("registros")}`}
                                    defaultPageSize={40}
                                    onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                                > </Pagination>
                                :
                                null

                        }
                    </div>

                    <div className='mantenimiento_item2' style={{ gap: '10px' }}>
                        <Select
                            disabled={grupos !== null ? false : true}
                            showSearch
                            allowClear={true}
                            value={filtroLocal.ID_GRUPO_MONTAJE === null ? traducirPagina("Seleccione_familia") : filtroLocal.ID_GRUPO_MONTAJE}
                            size={"large"}
                            placeholder={traducirPagina("Seleccione_familia")}
                            style={{ width: '240px', textAlign: 'left' }}
                            onChange={(e) => {
                                let ID_FAMILIA = e === undefined || e === null ? null : e

                                datosPaginacion.iniPage = 1;
                                setDatosPaginacion({ ...datosPaginacion })
                                ObtenerTarifaPorActualizacion(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, filtroLocal.TEXTO_BUSCADOR, ID_FAMILIA, filtroLocal.SIN_PRECIO)

                                filtroLocal.ID_GRUPO_MONTAJE = ID_FAMILIA
                                setFiltroLocal({ ...filtroLocal })

                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {grupos !== null && grupos.length > 0 ?
                                grupos.map((grupo) =>
                                    <Option key={grupo.ID} value={grupo.ID}>{grupo.NOMBRE}</Option>
                                )
                                :
                                null
                            }
                        </Select>


                        {/*tarifas === null ? { pointerEvents: 'none', opacity: '0.5', backgroundColor: '#eee', padding: '0px' } : { backgroundColor: '#eee', padding: '0px' }*/}

                        <div className="grid-container" style={{ backgroundColor: '#eee', padding: '0px' }}>
                            <div className="grid-item">
                                <input className="form-control eliminarFoco " type="text" aria-label="Search" placeholder={traducirPagina("Buscar_articulo")} style={{ backgroundColor: "transparent", border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off"
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            datosPaginacion.iniPage = 1;
                                            setDatosPaginacion({ ...datosPaginacion })
                                            ObtenerTarifaPorActualizacion(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, filtroLocal.TEXTO_BUSCADOR, filtroLocal.ID_GRUPO_MONTAJE, filtroLocal.SIN_PRECIO)
                                        }
                                    }}
                                    onChange={(e) => {
                                        filtroLocal.TEXTO_BUSCADOR = e.target.value;
                                        setFiltroLocal({ ...filtroLocal })
                                    }}
                                    value={filtroLocal.TEXTO_BUSCADOR} />
                            </div>

                            <div className="grid-item" onClick={(e) => {
                                datosPaginacion.iniPage = 1;
                                setDatosPaginacion({ ...datosPaginacion })
                                ObtenerTarifaPorActualizacion(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, "", filtroLocal.ID_GRUPO_MONTAJE, filtroLocal.SIN_PRECIO)
                            }}>
                                <button style={{ visibility: filtroLocal.TEXTO_BUSCADOR.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2 btnEliminarBuscador" onClick={(e) => { filtroLocal.TEXTO_BUSCADOR = ""; setFiltroLocal({ ...filtroLocal }) /*setLicencias(filtroLocalDeLaTabla("", licenciasAux));*/ }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                            </div>


                            <div className="grid-item" onClick={(e) => {
                                datosPaginacion.iniPage = 1;
                                setDatosPaginacion({ ...datosPaginacion })
                                ObtenerTarifaPorActualizacion(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, filtroLocal.TEXTO_BUSCADOR, filtroLocal.ID_GRUPO_MONTAJE, filtroLocal.SIN_PRECIO)
                            }}>
                                <button className="btn_buscador_tarifa">  <SearchOutlined style={{ fontSize: '20px' }} /> {traducirPagina("Buscar")} </button>
                            </div>

                            <div className="grid-item" onClick={(e) => {

                                filtroLocal.SIN_PRECIO = !filtroLocal.SIN_PRECIO
                                setFiltroLocal({ ...filtroLocal })

                                datosPaginacion.iniPage = 1;
                                setDatosPaginacion({ ...datosPaginacion })
                                ObtenerTarifaPorActualizacion(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, props.ID_ACTUALIZACION, filtroLocal.TEXTO_BUSCADOR, filtroLocal.ID_GRUPO_MONTAJE, filtroLocal.SIN_PRECIO)

                            }}>
                                <button className="btn_buscador_tarifa btn_filtro_cruce" > {filtroLocal.SIN_PRECIO ? <EyeOutlined style={{ fontSize: '20px' }} /> : <EyeInvisibleOutlined style={{ fontSize: '20px' }} />} {traducirPagina("Sin_precio")} </button>
                            </div>



                            <div className="grid-item">
                                <button className="btn_buscador_tarifa"
                                    style={{ backgroundColor: '#fff', color: '#00468e', borderRadius: '0px 5px 5px 0px', opacity: filtroLocal.LOADER_CSV ? '0.1' : "1", pointerEvents: grupos === null || filtroLocal.LOADER_CSV ? 'none' : 'all' }}
                                    onClick={() => {
                                        descargarFichero()
                                    }}

                                >
                                    {filtroLocal.LOADER_CSV ?
                                        <div style={{ height: '1.5rem', width: '1.5rem' }} className="spinner-border  fast colorSubAzul" role="status" disabled />
                                        :
                                        <CloudDownloadOutlined style={{ fontSize: '20px' }} />
                                    }
                                </button>
                            </div>

                        </div>


                    </div>
                </div>



                <div className='container_tarifas' style={{ height: `calc(100vh - ${(70 + alturaSubmenu)}px )` }}>

                    <table style={{ width: '100%', color: '#000' }} >
                        <thead>
                            <tr style={{ backgroundColor: '#e0e0e0' }}>
                                <th className="formatear_cabecera_icono" style={{ width: '140px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}
                                    onClick={(e) => {
                                        // actiual arrow-down
                                        const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                        ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                        ordenTabla.NUM_COLUM = 1

                                        ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 1 && ordenTabla.ACTIVO ? "A" : "D"
                                        ordenTabla.ORDER_COLUM = 1
                                        setOrdenTabla({ ...ordenTabla })

                                        ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)


                                    }}
                                >{traducirPagina("Referencia").toUpperCase()} {ordenTabla.NUM_COLUM === 1 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>} </th>

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 2

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 2 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 8
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} >{traducirPagina("Descripcion").toUpperCase()} {ordenTabla.NUM_COLUM === 2 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</th>

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 3

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 3 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 9
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ width: '260px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Familia").toUpperCase()} {ordenTabla.NUM_COLUM === 3 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</th>

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 4

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 4 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 3
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ width: '130px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("PVP").toUpperCase()} {ordenTabla.NUM_COLUM === 4 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</th>
                                <th className="formatear_cabecera_icono" onClick={(e) => {


                                }}
                                    style={{ width: '130px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("Anterior").toUpperCase()}</th>
                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 5

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 5 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 5
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ width: '130px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("Incremento").toUpperCase()} {ordenTabla.NUM_COLUM === 5 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</th>


                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 6

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 6 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 4
                                    setOrdenTabla({ ...ordenTabla })
                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)
                                }}
                                    style={{ width: '130px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}> {traducirPagina("Neto").toUpperCase()} {ordenTabla.NUM_COLUM === 6 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</th >

                                <th className="formatear_cabecera_icono" onClick={(e) => {


                                }}
                                    style={{ width: '130px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}> {traducirPagina("Anterior").toUpperCase()}</th >

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 7

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 7 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 6
                                    setOrdenTabla({ ...ordenTabla })
                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)
                                }}
                                    style={{ width: '130px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}> {traducirPagina("Incremento").toUpperCase()} {ordenTabla.NUM_COLUM === 7 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</th >

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 8


                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 8 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 7
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ width: '160px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Vigencia").toUpperCase()} {ordenTabla.NUM_COLUM === 8 && ordenTabla.ACTIVO ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</th >
                            </tr>
                        </thead>
                        <tbody>
                            {tarifas === null ?
                                null
                                :
                                tarifas !== null && tarifas.length > 0 ?
                                    tarifas.map((registro, i) =>
                                        <tr key={i} style={{ backgroundColor: '#fff' }} >
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{`${registro.REFERENCIA}`}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.DESCRIPCION}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.DESCRIPCION_FAMILIA}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right', backgroundColor: parseFloat(registro.PVP) !== 0 ? 'rgb(245, 245, 180)' : 'none' }}>{`${registro.PVP} `}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.PVP_ANTERIOR}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', color: colorPrecio(registro.PVP_INCREMENTO).COLOR }} >
                                                <div className="formatear_numero_icono">
                                                    {registro.PVP_INCREMENTO}
                                                    {colorPrecio(registro.PVP_INCREMENTO).INCREMENTO ? <ArrowUpOutlined></ArrowUpOutlined> : colorPrecio(registro.PVP_INCREMENTO).INCREMENTO === false ? <ArrowDownOutlined></ArrowDownOutlined> : null}
                                                </div>

                                            </td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right', backgroundColor: parseFloat(registro.NETO) !== 0 ? 'rgb(245, 245, 180)' : 'none' }}>{registro.NETO}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.NETO_ANTERIOR}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', color: colorPrecio(registro.NETO_INCREMENTO).COLOR }} >
                                                <div className="formatear_numero_icono">
                                                    {registro.NETO_INCREMENTO}
                                                    {colorPrecio(registro.NETO_INCREMENTO).INCREMENTO ? <ArrowUpOutlined></ArrowUpOutlined> : colorPrecio(registro.NETO_INCREMENTO).INCREMENTO === false ? <ArrowDownOutlined></ArrowDownOutlined> : null}
                                                </div>

                                            </td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.FECHA_VIGENCIA}</td>
                                        </tr>
                                    )
                                    :
                                    null

                            }
                        </tbody>
                    </table>


                    {tarifas === null ?
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>

                        </div>
                        :
                        tarifas !== null && tarifas.length > 0 ?
                            null
                            :
                            <div>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                            </div>
                    }

                    {bloqueoPantalla.LOADER ?
                        <div className="pantallaBloqueo">
                            <div className="image-mask-info" style={{ fontSize: '18px' }}>
                                <div dangerouslySetInnerHTML={{ __html: bloqueoPantalla.MENSAJE }}>

                                </div>
                            </div>
                        </div>

                        :

                        null
                    }

                </div>
            </Drawer>
        </>
    )
}

FichaActualizacion.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_ACTUALIZACION: PropTypes.number,

    ID_PROVEEDOR: PropTypes.number,
    ID_MARCA: PropTypes.number,
    NOMBRE_MARCA: PropTypes.string



};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaActualizacion);